import Stack from "@mui/material/Stack";
import { SxProps } from "@mui/material/styles";
import React from "react";

import { IgTypography } from "./IgTypography";

export interface IgNoRowsOverlayProps {
  message: string;
  sx?: SxProps;
}

/**
 * Centered empty-state overlay for data grids (or any container) that have no
 * rows to display. Renders a single muted message and fills its parent's
 * height so it sits centered over the empty grid body.
 */
export const IgNoRowsOverlay = ({ message, sx }: IgNoRowsOverlayProps) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={[
      { p: 3, height: "100%", textAlign: "center" },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <IgTypography color="text.secondary">{message}</IgTypography>
  </Stack>
);
